import { render, staticRenderFns } from "./InstructionFilesUpload.vue?vue&type=template&id=036389a8&scoped=true&"
import script from "./InstructionFilesUpload.vue?vue&type=script&lang=js&"
export * from "./InstructionFilesUpload.vue?vue&type=script&lang=js&"
import style0 from "./InstructionFilesUpload.vue?vue&type=style&index=0&id=036389a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036389a8",
  null
  
)

export default component.exports